import { SubscriptionStatus } from "./SubscriptionStatus";

const subs = new Set<() => void>();
const refetchSubs = new Set<() => void>();

export function notifyClientStatus(status: SubscriptionStatus) {
  subs.forEach((sub) => sub());
  if (status === SubscriptionStatus.refetching) {
    refetchSubs.forEach((sub) => sub());
  }
}
